import {useMemo} from 'react';
import {
  FlatColorSelector,
  FlatColorSelectorProps,
  Option,
} from '../../../flat-color-selector/flat-color-selector';

type CareServicesColorProps = Pick<
  FlatColorSelectorProps,
  'onChange' | 'label' | 'required' | 'disabled' | 'disabledTooltip' | 'errors'
> & {
  value: string;
};

export function CareServicesInputColor({value, ...rest}: CareServicesColorProps) {
  const colors = useMemo<Option[]>(() => {
    const colorOptions: Option[] = [];

    for (const color of SERVICE_SHIFT_COLORS) {
      colorOptions.push({
        key: color,
        label: color,
      });
    }

    return colorOptions;
  }, []);

  const valueOption = useMemo<Option | undefined>(() => {
    return colors.find((option) => option.key === value.toLowerCase());
  }, [colors, value]);

  return <FlatColorSelector {...rest} options={colors} value={valueOption} />;
}

// -----------------------------------------------------------------
// -----------------------------------------------------------------
// -----------------------------------------------------------------

export const DEFAULT_SERVICE_SHIFT_COLOR = '#90caf9';

const SERVICE_SHIFT_COLORS = [
  // Gray shades
  '#2d3748',
  '#5d6d7e',
  '#b0bec5',
  '#e5e8eb',
  // Red shades
  '#7f2727',
  '#b35b5b',
  '#ef9a9a',
  '#ffe1e5',
  // Brown/Orange shades
  '#8b542a',
  '#b9734c',
  '#ffcc80',
  '#ffe9c8',
  // Yellow/Gold shades
  '#7b642a',
  '#a8894e',
  '#fff176',
  '#fffde4',
  // Green shades
  '#2c5237',
  '#588f6c',
  '#a5d6a7',
  '#d9f0e6',
  // Teal shades
  '#2a544f',
  '#548680',
  '#80cbc4',
  '#c3e9e6',
  // Blue shades
  '#31427a',
  '#5f75c0',
  '#90caf9',
  '#ccecff',
  // Purple shades
  '#54387d',
  '#8566b8',
  '#b39ddb',
  '#e0d5f1',
];
